export interface ISnowplowSchema {
  schema: string;
  data: { [key: string]: any };
}

export interface ISnowplowContext {
  schemaName?: string;
  parseSchema: (id: string) => ISnowplowSchema;
}

export interface IStructuredEvent {
  category: string;
  action: string;
  label?: string;
  property?: string;
  value?: number;
}

export class SnowplowContext {
  public schemaName: string;
  public parseSchema: (schema: string) => ISnowplowSchema;

  constructor(schemaName: string, data: { [key: string]: any }) {
    this.schemaName = schemaName;
    this.parseSchema = (schema: string) => {
      return {schema, data};
    };
  }
}
